import { isNil } from 'lodash/fp';
import { selectView } from 'app/store/view';
import { toStringFqn } from 'app/lib/utils';
import {
    DOWNLOAD_VIEW_FAILED,
    DOWNLOAD_VIEW_INITIATED,
    PREPARE_DOWNLOAD,
    VIEW_DOWNLOAD
} from './types.js';

const doDownloadInitiated = (viewName) => ({
    type: DOWNLOAD_VIEW_INITIATED,
    payload: { viewName }
});

const doPrepareDownloadQuery = ({ viewUuid, viewName }) => ({
    type: PREPARE_DOWNLOAD,
    api: { version: 2, name: 'InitiatePrepareDownload' },
    params: {
        viewUuid
    },
    meta: {
        viewName,
        viewUuid
    },
    onProgress: ({ dispatch, responseName, meta }) => {
        if (responseName === 'PreparedDownloadInitiated') {
            const { viewName } = meta;
            dispatch(doDownloadInitiated(viewName));
        }
    }
});

export const doPrepareDownload = (fqn) => ({
    type: VIEW_DOWNLOAD,
    effect: ({ store }) => {
        if (!isNil(fqn)) {
            store.dispatch(doPrepareDownloadQuery({ viewUuid: fqn, viewName: toStringFqn(fqn) }));
        } else {
            const state = store.getState();
            const view = selectView(state);

            store.dispatch(doPrepareDownloadQuery({ viewUuid: view.uuid, viewName: view.name }));
        }
    }
});

export const doDownloadFailed = (viewName, error) => ({
    type: DOWNLOAD_VIEW_FAILED,
    payload: { viewName, error }
});
